
import Vue from 'vue';

// Assets
import AonLogo from '~/assets/img/aon.svg';
import HigheredLogo from '~/assets/img/HigheredLogo.svg';

export default Vue.extend({
    name: 'AssessmentFooter',
    data: () => ({
        aonLogo: AonLogo,
        higheredLogo: HigheredLogo,
    }),
});
